import { IServicePersons } from "../interfaces";

export function getLenkaPersons() {
	const output: Array<IServicePersons> = [];

	output.push({
		group: "lenka-svoje",
		items: [
			{ key: "ALB_BRU", fullName: "Albus Brumbál", sex: "M", birthdate: "1881-08" },
		],
	});

	return output;
}
